import MediaPlayer from "../MediaPlayer";
import m, {Vnode} from "mithril";
import {getPercentOffsetXFromEvent} from "../../../helpers"

export default class Seeker {

    private isSeeking = false;
    private isPlayingBeforeSeek = false;

    constructor(
        public readonly player: MediaPlayer,
        private enabled: boolean
    ) { }

    public enable(): void {
        this.enabled = true;
    }

    public view(): Vnode {
        const pos = (this.player.duration() ? this.player.currentTime() / this.player.duration() : 0)*100
        return m('.seeker' + (this.enabled?'.enabled':'.disabled') + (this.isSeeking?'.seeking':''), {
            onmousedown: (e: MouseEvent) => {
                if (this.enabled) {
                    e.preventDefault();
                    this.isSeeking = true;
                    this.isPlayingBeforeSeek = this.player.isPlaying();
                    this.player.pause();
                    this.updatePlayerCurrentTime(e);
                }
            },
            onmouseup: (e: MouseEvent) => {
                if (this.isSeeking) {
                    this.isSeeking = false;
                    this.updatePlayerCurrentTime(e);
                    if (this.isPlayingBeforeSeek) {
                        this.player.play();
                    }
                    this.isPlayingBeforeSeek = false;
                }
            },
            onmousemove: (e: MouseEvent) => {
                if (this.isSeeking) {
                    this.updatePlayerCurrentTime(e);
                }
            },
            onmouseleave: (e: MouseEvent) => {
                if (this.isSeeking) {
                    this.updatePlayerCurrentTime(e)
                    this.isSeeking = false;
                }
            },
            onmouseenter: (e: MouseEvent) => {
                if (this.enabled && e.buttons === 1) { // users mouse can accidentally leave seeker area and come back
                    this.isSeeking = true;
                    this.updatePlayerCurrentTime(e);
                    this.player.pause();
                }
            },
            ontouchstart: (e: TouchEvent) => {
                if (this.enabled) {
                    e.preventDefault(); // prevent scroll
                    this.isSeeking = true;
                    this.isPlayingBeforeSeek = this.player.isPlaying();
                    this.player.pause();
                    this.updatePlayerCurrentTime(e);
                }
            },
            ontouchmove: (e: TouchEvent) => {
                if (this.isSeeking) {
                    this.updatePlayerCurrentTime(e);
                }
            },
            ontouchend: () => {
                this.isSeeking = false;
                if (this.isPlayingBeforeSeek) {
                    this.player.play();
                }
            },
            ontouchcancel: () => {
                this.isSeeking = false;
            }
        }, [
            m('.seeker-background'),
            m('.seeker-foreground', {
                style: {
                    width: (pos)+'%',
                }
            }),
            m('.seeker-rider', { // 🎠
                style: {
                    left: (pos)+'%',
                }
            }),
        ])
    }

    private updatePlayerCurrentTime(e: MouseEvent|TouchEvent): void {
        this.player.seek(getPercentOffsetXFromEvent(e) * this.player.duration());
    }


}